import { render, staticRenderFns } from "./ComplaintsList.vue?vue&type=template&id=bee81120&scoped=true"
import script from "./ComplaintsList.vue?vue&type=script&lang=js"
export * from "./ComplaintsList.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsList.vue?vue&type=style&index=0&id=bee81120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee81120",
  null
  
)

export default component.exports